import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import enFlag from 'common/assets/icons/common/flags/en.png';
import ruFlag from 'common/assets/icons/common/flags/ru.png';
import hiFlag from 'common/assets/icons/common/flags/hi.png';
import viFlag from 'common/assets/icons/common/flags/vi.svg';
import arrowSrc from 'common/assets/icons/common/arrows/pointers/dark-blue-top-arrow-pointer.svg';
import { useWindowSize } from 'common/utils/style.util';

import * as S from './styled';
import { DropdownPopover } from '../DropdownPopover';
import initFreshChat from '../../initFreshChat';

const options = [
  {
    value: 'en',
    shortLabel: 'En',
    label: 'English',
    icon: enFlag,
  },
  {
    value: 'ru',
    shortLabel: 'Ру',
    label: 'Русский',
    icon: ruFlag,
  },
  {
    value: 'hi',
    shortLabel: 'हिन्दी',
    label: 'हिन्दी',
    icon: hiFlag,
  },
  {
    value: 'vi',
    shortLabel: 'Vn',
    label: 'Tiếng Việt',
    icon: viFlag,
  },
];

export const LanguageSwitcher = ({ placement }) => {
  const { i18n } = useTranslation();
  const [value, setValue] = useState(i18n.language || 'en');
  const { width } = useWindowSize();
  const notADesktop = width < 700;

  useEffect(() => {
    setValue(i18n.language);
  }, [i18n.language]);

  return (
    <DropdownPopover
      offset={7}
      placement={placement}
      value={value}
      options={options}
      renderOptions={({ options, close }) => (
        <S.Options>
          {options.map((option) => (
            <S.Option
              onClick={() => {
                setValue(option.value);
                i18n.changeLanguage(option.value);
                window.fcWidget.user.setLocale(option.value);
                window.fcWidget.destroy();
                initFreshChat();
                close();
              }}
              key={option.value}
            >
              <S.Flag src={option.icon} />
              <div>{option.label}</div>
            </S.Option>
          ))}
        </S.Options>
      )}
    >
      {({ selectedOption, open }) => (
        <S.Trigger>
          <S.TriggerIconWrapper>
            <S.TriggerIcon src={selectedOption.icon} />
          </S.TriggerIconWrapper>
          <S.TriggerText>
            {notADesktop ? selectedOption.shortLabel : selectedOption.label}
          </S.TriggerText>
          <S.TriggerArrow open={open} src={arrowSrc} />
        </S.Trigger>
      )}
    </DropdownPopover>
  );
};
